import React from 'react';
import { useTranslation } from 'react-i18next';

import { API_URL } from '../../../../../config/constants';
import GenericCard from '../../../../GenericCard';
import type { SearchAllContentHit } from '../../../types';

interface Props {
  hit: SearchAllContentHit;
  className: string;
}

const EXCLUDED_CONTENT_TYPE_LABELS = ['basic_page', 'detail_page', 'landing_page', 'overview_page'];

const SearchAllContentResultsGenericHit: React.FC<Props> = (props) => {
  const { hit, className } = props;

  const { t } = useTranslation();

  const makeLabel = () => {
    const hitHasParent = hit.parent_uuid !== undefined;
    const hitHasType =
      hit.type !== undefined && !EXCLUDED_CONTENT_TYPE_LABELS.includes(hit.type[0]);
    let translationKey = '';

    // this function is able to handle all the generic search types properly
    // if the hit has a parent then it is an Onderwerp result
    // if the hit has a type then it will have that content type in the translations
    // if the hit is some other type and contains a vid type which is only for taxonomy terms,
    //   then it will have that type in the translations
    if (hitHasParent) translationKey = 'taxonomy_term.child';
    else if (hitHasType) translationKey = `content_types.${hit.type[0]}`;
    else if (hit.vid && hit.vid[0]) translationKey = `taxonomy_term.${hit.vid[0]}`;

    return translationKey !== '' ? t(translationKey) : undefined;
  };

  return (
    <GenericCard
      className={className}
      title={hit.page_title?.[0] || hit.name?.[0]}
      label={makeLabel()}
      subtitle={hit.body_summarized?.[0] || hit.description?.[0]}
      link={hit.url[0]}
      profile={{
        name: hit.author_full_name?.[0] || hit.contact_person_full_name?.[0],
        image: hit.author_profile_picture?.[0] || hit.contact_person_profile_picture?.[0],
      }}
      image={hit.image_svg_url ? `${API_URL}${hit.image_svg_url[0]}` : hit.image_style_uri?.[0]}
    />
  );
};

export default SearchAllContentResultsGenericHit;
